
// ==========================
// Swym Availability Checker
// ==========================

(function () {

  if (window.__wishlistAvailabilityCheck) return;
  window.__wishlistAvailabilityCheck = true;

  const ROOT = document.documentElement;

  ROOT.classList.remove('wishlist-ready', 'wishlist-disabled');
  ROOT.classList.add('wishlist-loading');

  function showWishlist() {
    ROOT.classList.add('wishlist-ready');
    ROOT.classList.remove('wishlist-loading', 'wishlist-disabled');
    console.log('[Wishlist Availability] ready');
  }

  function hideWishlist() {
    ROOT.classList.add('wishlist-disabled');
    ROOT.classList.remove('wishlist-loading', 'wishlist-ready');
    console.warn('[Wishlist Availability] disabled');
  }

  function hasSwymButtons() {
    return !!document.querySelector(
      '.swym-button, .swym-add-to-wishlist-view-product, [data-swaction="addToWishlist"], .swym-wishlist'
    );
  }

  function isSwymReady() {

    // ✅ FORCE DISABLE
    if (window.WISHLIST_FORCE_DISABLE === true) {
      return false;
    }

    return (
      (window._swat && typeof window._swat.addToWishList === 'function') ||
      hasSwymButtons()
    );
  }

  let attempts = 0;
  const maxAttempts = 60;

  const timer = setInterval(function () {

    attempts++;

    // ✅ FORCE DISABLE
    if (window.WISHLIST_FORCE_DISABLE === true) {
      hideWishlist();
      clearInterval(timer);
      return;
    }

    if (isSwymReady()) {
      showWishlist();
      clearInterval(timer);
      return;
    }

    if (attempts >= maxAttempts) {
      hideWishlist();
      clearInterval(timer);
    }

  }, 500);

})();
